/** Mirrors backend `Sestek.AgenticCX.Enums.DateDisplayFormat`. */
export enum DateDisplayFormat {
  DayMonthYear = 1,
  MonthDayYear = 2,
  YearMonthDay = 3,
}
